<template>
  <div class="box-detail">
    <div class="box-left">
      <div class="box-left-header">
        <div @click="$router.push({ path: '/Companys' })" class="goBack c-m-0">
          <i class="el-icon-arrow-left"></i>
          <span>公司</span>
          <i class="el-icon-s-custom"></i>
        </div>
      </div>
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :fields="extFields"
          :area="area"
          :options="options"
          ref="form"
          labelWidth="150px"
          @changeForm="osg.changeForm"
        >
          <template slot="address">
            <el-input
              v-model="formData.address"
              suffix-icon="el-icon-map-location"
              @blur="osg.getGeocode()"
            ></el-input>
          </template>
        </c-form>
      </div>
      <div class="box-left-footer">
        <el-button
          :disabled="osg.has('Companys,edit') ? false : true"
          type="primary"
          @click="doSave"
        >
          提交
        </el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <!-- 动态 笔记 -->
    <div class="box-center">
      <el-tabs v-model="activeTab" @tab-click="tabClick" class="c-h-1 c-flex c-flex-col">
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">{{ log.content }}</div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.updateUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote" @close="vqeditor.content = ''">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="通话记录" name="callRecords">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="callRecords.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getCallRecords"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入主叫/被叫号码"
                v-model="callRecords.searchValue"
                class="search-input"
                clearable
                @clear="getCallRecords"
                @keyup.enter.native="getCallRecords"
              >
                <el-button slot="append" icon="el-icon-search" @click="getCallRecords"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(item, i) in callRecords.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-phone-outline c-w-30"></i>
                  <span v-if="item.callType == '1'">内部通话</span>
                  <span v-if="item.callType == '2'">呼入</span>
                  <span v-else-if="item.callType == '3'">呼出</span>
                </span>
                <span>{{ formatCallResult(item.callResult) }}</span>
              </div>
              <div class="activity-card-content">
                <!-- <div>主叫：{{ item.callerName }} {{ item.caller }}</div>
                <div>
                  被叫：{{
                    item.callWay == 4
                      ? item.calleeName || ''
                      : item.callDirection == '0'
                      ? item.calleeName || ''
                      : item.calleeName || formData.name || ''
                  }}{{ ' ' + item.callee }}
                </div> -->
                <div v-if="item.callType == '2'">主叫：{{ item.customerNumber }}</div>
                <div v-if="item.callType == '3'">被叫：{{ item.customerNumber }}</div>
                <div>通话时间：{{ item.startTimeStr }} 至 {{ item.endTimeStr }}</div>
                <audio v-if="item.recordUrl" class="c-m-t-15" controls :src="item.recordUrl">
                  您的浏览器不支持 audio 标签。
                </audio>
              </div>
              <div class="activity-card-footer">
                <!-- <span>操作人：{{ item.createUserName }}</span> -->
                <span></span>
                <span>生成记录时间：{{ item.createTime }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="属性变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      class="box-right"
      :class="collapse ? 'box-collapse' : ''"
      v-if="
        osg.has('Companys,contact') ||
          osg.has('Companys,serviceAppointment') ||
          osg.has('Companys,address') ||
          osg.has('Companys,machine')
      "
    >
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <el-collapse>
          <el-collapse-item v-if="osg.has('Companys,contact')">
            <template slot="title">
              <span>联系人</span>
              <el-button type="text" icon="el-icon-plus" @click.stop="newContact">
                添加联系人
              </el-button>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of contact.relatedData" :key="i">
                <div>
                  <i class="el-icon-office-building card-item-logo"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/contact/' + item._id" target="_blank">
                      姓名：{{ item.name }}
                    </el-link>
                  </p>
                  <p>手机：{{ item.phone }}</p>
                </div>
                <i class="el-icon-close card-item-icon-remove" @click="removeContact(item)"></i>
                <i
                  class="el-icon-edit card-item-icon-edit"
                  @click="editContact(item)"
                  v-if="false"
                ></i>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item v-if="osg.has('Companys,serviceAppointment')">
            <template slot="title">
              <span>工单</span>
              <el-button type="text" icon="el-icon-plus" @click.stop="newServiceAppointment">
                添加工单
              </el-button>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of serviceAppointment.relatedData" :key="i">
                <div>
                  <i class="el-icon-tickets card-item-logo"></i>
                </div>
                <div>
                  <p>
                    <el-link
                      @click="osg.open('', '', '_blank', '/ServiceAppointment/' + item._id)"
                      target="_blank"
                    >
                      标题：{{ item.title }}
                    </el-link>
                  </p>
                  <p v-if="item.status">状态：{{ osg.codelabel('status', item.status) }}</p>
                </div>
                <i
                  class="el-icon-close card-item-icon-remove"
                  @click="removeServiceAppointment(item)"
                ></i>
                <i
                  class="el-icon-edit card-item-icon-edit"
                  @click="editServiceAppointment(item)"
                  v-if="false"
                ></i>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item v-if="osg.has('Companys,address')">
            <template slot="title">
              <span>地址</span>
              <el-button type="text" icon="el-icon-plus" @click.stop="newAddress">
                添加地址
              </el-button>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of address.relatedData" :key="i">
                <div>
                  <i class="el-icon-location-information card-item-logo"></i>
                </div>
                <div>
                  <p>
                    <el-link
                      @click="osg.open('', '', '_blank', '/Address/' + item._id)"
                      target="_blank"
                    >
                      {{ item.address }}
                    </el-link>
                  </p>
                  <p></p>
                </div>
                <i class="el-icon-close card-item-icon-remove" @click="removeAddress(item)"></i>
                <i
                  class="el-icon-edit card-item-icon-edit"
                  @click="editAddress(item)"
                  v-if="false"
                ></i>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item v-if="osg.has('Companys,machine')">
            <template slot="title">
              <span>机台</span>
              <el-button type="text" icon="el-icon-plus" @click.stop="newMachine">
                添加机台
              </el-button>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of machine.relatedData" :key="i">
                <div>
                  <i class="el-icon-office-building card-item-logo"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/ExtFormDetail/machine/' + item._id" target="_blank">
                      编号：{{ item.number }}
                    </el-link>
                  </p>
                  <p v-if="item.number">类型：{{ osg.codelabel('machineType', item.type) }}</p>
                </div>
                <i class="el-icon-close card-item-icon-remove" @click="removeMachine(item)"></i>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <el-drawer
        custom-class="c-drawer"
        title="添加工单"
        :visible.sync="serviceAppointment.openRelate"
        direction="rtl"
      >
        <div class="el-drawer__content">
          <el-tabs v-model="serviceAppointment.activeName" type="card">
            <el-tab-pane label="选择已有工单" name="search">
              <p class="c-m-b-10 c-font-13">
                请输入工单标题/联系人名称进行搜索
              </p>
              <el-select
                v-model="serviceAppointment.searchObj"
                filterable
                remote
                reserve-keyword
                placeholder
                :remote-method="getServiceAppointmentData"
                :loading="false"
                clearable
                @clear="getServiceAppointmentData"
                @change="$forceUpdate()"
                class="c-w-1"
              >
                <el-option
                  v-for="item in serviceAppointment.data"
                  :key="item._id"
                  :label="item.title"
                  :value="item"
                >
                  <span class="c-fl">标题：{{ item.title }}</span>
                  <span class="c-fr c-font-13">{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-tab-pane>
            <el-tab-pane label="新建工单" name="create" v-if="false">
              <el-form
                :model="serviceAppointment.formData"
                :rules="rules"
                ref="serviceAppointmentFormData"
                label-width="90px"
                label-position="left"
                hide-required-asterisk:true
              >
                <el-form-item label="客户姓名" prop="name">
                  <el-input
                    v-model="serviceAppointment.formData.name"
                    suffix-icon="el-icon-mobile-phone"
                  ></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                  <el-input
                    v-model="serviceAppointment.formData.phone"
                    suffix-icon="el-icon-mobile-phone"
                  ></el-input>
                </el-form-item>
                <el-form-item label="省市区" prop="area" v-if="serviceAppointment.openRelate">
                  <el-cascader
                    :props="area.props"
                    v-model="serviceAppointment.formData.area"
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                  <el-input
                    v-model="serviceAppointment.formData.address"
                    suffix-icon="el-icon-map-location"
                  ></el-input>
                </el-form-item>
                <el-form-item label="工单标题" prop="title">
                  <el-input v-model="serviceAppointment.formData.title"></el-input>
                </el-form-item>
                <el-form-item label="优先级">
                  <el-radio-group
                    v-model="serviceAppointment.formData.priority"
                    @change="$forceUpdate()"
                  >
                    <el-radio
                      v-for="item of options.priority"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="预约时间" prop="applyTime">
                  <el-date-picker
                    v-model="serviceAppointment.formData.applyTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="选择日期时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="描述" prop="describe">
                  <el-input type="textarea" :rows="2" v-model="formData.describe"></el-input>
                </el-form-item>
                <el-form-item label="阶段">
                  <el-select v-model="serviceAppointment.formData.stage">
                    <el-option
                      v-for="item in options.stage"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="serviceAppointment.formData.status">
                    <el-option
                      v-for="item in options.status"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      v-show="serviceAppointment.formData.stage == item.value.slice(0, -2)"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="el-drawer__footer" v-if="serviceAppointment.activeName == 'search'">
          <el-button
            type="primary"
            :disabled="!serviceAppointment.searchObj._id"
            @click="
              saveServiceAppointment('search');
              initServiceAppointment();
            "
          >
            保存
          </el-button>
          <el-button plain @click="initServiceAppointment()">取消</el-button>
        </div>
        <div class="el-drawer__footer" v-if="serviceAppointment.activeName == 'create'">
          <el-button type="primary" @click="saveServiceAppointment('create')">保存</el-button>
          <el-button plain @click="initServiceAppointment">取消</el-button>
        </div>
      </el-drawer>
      <el-drawer
        custom-class="c-drawer"
        title="编辑工单"
        :visible.sync="serviceAppointment.openEdit"
        direction="rtl"
        :before-close="initServiceAppointment"
      >
        <div class="el-drawer__content">
          <el-form
            :model="serviceAppointment.formData"
            :rules="rules"
            ref="serviceAppointmentFormData"
            label-width="90px"
            label-position="left"
            hide-required-asterisk:true
          >
            <el-form-item label="客户姓名" prop="name">
              <el-input
                v-model="serviceAppointment.formData.name"
                suffix-icon="el-icon-mobile-phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="serviceAppointment.formData.phone"
                suffix-icon="el-icon-mobile-phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="省市区" prop="area" v-if="serviceAppointment.openEdit">
              <el-cascader
                :props="area.props"
                v-model="serviceAppointment.formData.area"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
              <el-input
                v-model="serviceAppointment.formData.address"
                suffix-icon="el-icon-map-location"
              ></el-input>
            </el-form-item>
            <el-form-item label="工单标题" prop="title">
              <el-input v-model="serviceAppointment.formData.title"></el-input>
            </el-form-item>
            <el-form-item label="优先级">
              <el-radio-group
                v-model="serviceAppointment.formData.priority"
                @change="$forceUpdate()"
              >
                <el-radio v-for="item of options.priority" :key="item.value" :label="item.value">
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="预约时间" prop="applyTime">
              <el-date-picker
                v-model="serviceAppointment.formData.applyTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="描述" prop="describe">
              <el-input type="textarea" :rows="2" v-model="formData.describe"></el-input>
            </el-form-item>
            <el-form-item label="阶段">
              <el-select v-model="serviceAppointment.formData.stage">
                <el-option
                  v-for="item in options.stage"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="serviceAppointment.formData.status">
                <el-option
                  v-for="item in options.status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-show="serviceAppointment.formData.stage == item.value.slice(0, -2)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="el-drawer__footer">
          <el-button type="primary" @click="saveServiceAppointment()">保存</el-button>
          <el-button plain @click="initServiceAppointment()">取消</el-button>
        </div>
      </el-drawer>

      <el-drawer
        custom-class="c-drawer"
        title="添加联系人"
        :visible.sync="contact.openRelate"
        direction="rtl"
      >
        <div class="el-drawer__content">
          <el-tabs v-model="contact.activeName" type="card">
            <el-tab-pane label="选择已有联系人" name="search">
              <p class="c-m-b-10 c-font-13">请输入联系人姓名进行搜索</p>
              <el-select
                v-model="contact.search_contact"
                filterable
                remote
                reserve-keyword
                placeholder
                suffix-icon="el-icon-date"
                :remote-method="getContactData"
                clearable
                @clear="getContactData"
                :loading="false"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="item in contact.data"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </el-tab-pane>
            <el-tab-pane label="新建联系人" name="create" v-if="false">
              <el-form
                :model="contact.formData"
                :rules="rules"
                ref="contactFormData"
                label-width="90px"
                label-position="left"
                hide-required-asterisk:true
              >
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="contact.formData.name" suffix-icon="el-icon-user"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                  <el-input
                    v-model="contact.formData.phone"
                    suffix-icon="el-icon-mobile-phone"
                  ></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="contact.formData.email"
                    suffix-icon="el-icon-message"
                  ></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="address">
                  <el-input
                    v-model="contact.formData.address"
                    suffix-icon="el-icon-map-location"
                  ></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="leadStatus">
                  <el-select v-model="contact.formData.leadStatus">
                    <el-option
                      v-for="item in options.leadStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="阶段" prop="lifecycleStage">
                  <el-select v-model="contact.formData.lifecycleStage">
                    <el-option
                      v-for="item in options.lifecycleStage"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-for="(extField, idx) in extFields"
                  :key="idx"
                  :label="extField.nameDisp"
                >
                  <template
                    v-if="
                      extField.type == 'text' ||
                        extField.type == 'textarea' ||
                        extField.type == 'number'
                    "
                  >
                    <el-input
                      v-model="contact.formData.exts[extField.name]"
                      :type="extField.type"
                    ></el-input>
                  </template>
                  <template v-if="extField.type == 'radio'">
                    <el-radio-group v-model="formData.exts[extField.name]">
                      <el-radio
                        v-for="item in options[extField.valueOption]"
                        :key="item.value"
                        :label="item.value"
                      >
                        {{ item.label }}
                      </el-radio>
                    </el-radio-group>
                  </template>
                  <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
                    <el-checkbox-group v-model="formData.exts[extField.name]">
                      <el-checkbox
                        v-for="item in options[extField.valueOption]"
                        :label="item.value"
                        :key="item.value"
                      >
                        {{ item.label }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </template>
                  <template v-if="extField.type == 'select'">
                    <el-select
                      v-model="contact.formData.exts[extField.name]"
                      placeholder="请选择"
                      clearable
                    >
                      <el-option
                        v-for="item in options[extField.valueOption]"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </template>
                  <template v-if="extField.type == 'time'">
                    <el-time-select
                      v-model="contact.formData.exts[extField.name]"
                      placeholder="选择时间"
                    ></el-time-select>
                  </template>
                  <template v-if="extField.type == 'date' || extField.type == 'datetime'">
                    <el-date-picker
                      v-model="contact.formData.exts[extField.name]"
                      :type="extField.type"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </template>
                  <template v-if="extField.type == 'switch'">
                    <el-switch
                      v-model="contact.formData.exts[extField.name]"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0"
                    ></el-switch>
                  </template>
                  <template v-if="extField.type == 'rate'">
                    <el-rate
                      v-model="contact.formData.exts[extField.name]"
                      @change="$forceUpdate()"
                    ></el-rate>
                  </template>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="el-drawer__footer" v-if="contact.activeName == 'search'">
          <el-button
            type="primary"
            @click="
              doSaveContact();
              initCompany();
            "
          >
            保存
          </el-button>
          <el-button
            plain
            @click="
              getData();
              initCompany();
            "
          >
            取消
          </el-button>
        </div>
        <div class="el-drawer__footer" v-if="contact.activeName == 'create'">
          <el-button
            type="primary"
            @click="
              saveCompany(true);
              initCompany();
            "
          >
            保存
          </el-button>
          <el-button plain @click="initCompany">取消</el-button>
        </div>
      </el-drawer>
      <el-drawer
        custom-class="c-drawer"
        title="编辑联系人"
        :visible.sync="contact.openEdit"
        direction="rtl"
        :before-close="initCompany"
      >
        <div class="el-drawer__content">
          <el-form
            :model="contact.formData"
            :rules="rules"
            ref="contactFormData"
            label-width="90px"
            label-position="left"
            hide-required-asterisk:true
          >
            <el-form-item label="姓名" prop="name">
              <el-input v-model="contact.formData.name" suffix-icon="el-icon-user"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="contact.formData.phone"
                suffix-icon="el-icon-mobile-phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="contact.formData.email" suffix-icon="el-icon-message"></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input
                v-model="contact.formData.address"
                suffix-icon="el-icon-map-location"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="leadStatus">
              <el-select v-model="contact.formData.leadStatus">
                <el-option
                  v-for="item in options.leadStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="阶段" prop="lifecycleStage">
              <el-select v-model="contact.formData.lifecycleStage">
                <el-option
                  v-for="item in options.lifecycleStage"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-for="(extField, idx) in extFields"
              :key="idx"
              :label="extField.nameDisp"
            >
              <template
                v-if="
                  extField.type == 'text' ||
                    extField.type == 'textarea' ||
                    extField.type == 'number'
                "
              >
                <el-input
                  v-model="contact.formData.exts[extField.name]"
                  :type="extField.type"
                ></el-input>
              </template>
              <template v-if="extField.type == 'radio'">
                <el-radio-group v-model="formData.exts[extField.name]">
                  <el-radio
                    v-for="item in options[extField.valueOption]"
                    :key="item.value"
                    :label="item.value"
                  >
                    {{ item.label }}
                  </el-radio>
                </el-radio-group>
              </template>
              <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
                <el-checkbox-group v-model="formData.exts[extField.name]">
                  <el-checkbox
                    v-for="item in options[extField.valueOption]"
                    :label="item.value"
                    :key="item.value"
                  >
                    {{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </template>
              <template v-if="extField.type == 'select'">
                <el-select
                  v-model="contact.formData.exts[extField.name]"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="item in options[extField.valueOption]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
              <template v-if="extField.type == 'time'">
                <el-time-select
                  v-model="contact.formData.exts[extField.name]"
                  placeholder="选择时间"
                ></el-time-select>
              </template>
              <template v-if="extField.type == 'date' || extField.type == 'datetime'">
                <el-date-picker
                  v-model="contact.formData.exts[extField.name]"
                  :type="extField.type"
                  placeholder="选择日期"
                ></el-date-picker>
              </template>
              <template v-if="extField.type == 'switch'">
                <el-switch
                  v-model="contact.formData.exts[extField.name]"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value="1"
                  inactive-value="0"
                ></el-switch>
              </template>
              <template v-if="extField.type == 'rate'">
                <el-rate
                  v-model="contact.formData.exts[extField.name]"
                  @change="$forceUpdate()"
                ></el-rate>
              </template>
            </el-form-item>
          </el-form>
        </div>
        <div class="el-drawer__footer">
          <el-button
            type="primary"
            @click="
              saveCompany(true);
              initCompany();
            "
          >
            保存
          </el-button>
          <el-button plain @click="initCompany()">取消</el-button>
        </div>
      </el-drawer>

      <!-- <el-drawer
        custom-class="c-drawer"
        title="地址信息"
        :visible.sync="address.openEdit"
        direction="rtl"
      >
        <div class="el-drawer__content">
          <el-form
            :model="address.formData"
            :rules="rules"
            ref="addressFormData"
            label-width="110px"
            label-position="left"
            hide-required-asterisk:true
          >
            <el-form-item label="地址" prop="address">
              <el-input v-model="address.formData.address"></el-input>
            </el-form-item>
            <el-form-item label="地址类型" prop="addressType">
              <el-select v-model="address.formData.addressType">
                <el-option
                  v-for="item in options.addressType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.value != '1'"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地址说明" prop="addressDescription">
              <el-input v-model="address.formData.addressDescription"></el-input>
            </el-form-item>
            <el-form-item label="地理编码准确度" prop="accuracy">
              <el-input v-model="address.formData.accuracy"></el-input>
            </el-form-item>
            <el-form-item label="经度" prop="longitude">
              <el-input
                v-model="address.formData.longitude"
                suffix-icon="el-icon-map-location"
              ></el-input>
            </el-form-item>
            <el-form-item label="纬度" prop="dimension">
              <el-input
                v-model="address.formData.dimension"
                suffix-icon="el-icon-map-location"
              ></el-input>
            </el-form-item>
            <el-form-item label="位置类型" prop="locationType">
              <el-select v-model="address.formData.locationType">
                <el-option
                  v-for="item in options.locationType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="邮编" prop="zipCode">
              <el-input
                v-model="address.formData.zipCode"
                suffix-icon="el-icon-map-location"
              ></el-input>
            </el-form-item>
            <el-form-item label="国家" prop="country">
              <el-input
                v-model="address.formData.country"
                suffix-icon="el-icon-map-location"
              ></el-input>
            </el-form-item>
            <el-form-item label="省市区" prop="area" v-if="address.openEdit">
              <el-cascader :props="area.props" v-model="address.formData.area"></el-cascader>
            </el-form-item>
            <el-form-item label="街道地址" prop="streetName">
              <el-input
                v-model="address.formData.streetName"
                suffix-icon="el-icon-map-location"
              ></el-input>
            </el-form-item>
            <el-form-item label="时区" prop="timeZone">
              <el-input
                v-model="address.formData.timeZone"
                suffix-icon="el-icon-map-location"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="el-drawer__footer">
          <el-button type="primary" @click="saveAddress()">保存</el-button>
          <el-button plain @click="initAddress()">取消</el-button>
        </div>
      </el-drawer> -->

      <el-drawer
        custom-class="c-drawer"
        title="添加机台"
        :visible.sync="machine.openRelate"
        direction="rtl"
      >
        <div class="el-drawer__content">
          <el-tabs v-model="machine.activeName" type="card">
            <el-tab-pane label="选择机台" name="search">
              <p class="c-m-b-10 c-font-13">请输入机台名称或编号搜索</p>
              <el-select
                v-model="machine.search_contact"
                filterable
                remote
                reserve-keyword
                placeholder
                suffix-icon="el-icon-date"
                :remote-method="getMachineData"
                clearable
                @clear="getMachineData"
                :loading="false"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="item in machine.data"
                  :key="item._id"
                  :label="item.number"
                  :value="item._id"
                ></el-option>
              </el-select>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="el-drawer__footer">
          <el-button
            type="primary"
            @click="
              saveMachine();
              initMachine();
            "
          >
            保存
          </el-button>
          <el-button
            plain
            @click="
              getData();
              initMachine();
            "
          >
            取消
          </el-button>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'company',
  props: {
    serviceState: {
      type: String
    }
  },
  data() {
    let that = this;
    return {
      id: null,
      companyType: '',
      collapse: false,
      formData: { exts: {}, foundTime: '' },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      fpi: {},
      options: {
        //公司
        codecfg_companytype: { codeId: 'COMPANYTYPE' },
        codecfg_industry: { codeId: 'INDUSTRY' },
        codecfg_callResult: { codeId: 'callResult' },
        //工单
        codecfg_priority: { codeId: 'PRIORITY' },
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_status: { codeId: 'STATUS' },
        //联系人
        codecfg_leadStatus: { codeId: 'LEADSTATUS' },
        codecfg_lifecycleStage: { codeId: 'LIFECYCLESTAGE' },
        //地址
        codecfg_addressType: { codeId: 'ADDRESSTYPE' },
        codecfg_locationType: { codeId: 'LOCATIONTYPE' },
        //机台
        codecfg_machineType: { codeId: 'machineType' }
      },
      rules: this.$util.rules,
      activeTab: 'log',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      // 笔记
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      // 通话记录
      callRecords: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      // 属性变更记录
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      contactList: [],
      contact: {
        relatedData: [], //关联的数组
        openRelate: false, //是否打开表单
        openEdit: false, //是否打开编辑表单
        data: [], //搜索已有的公司 返回的数组 可以叫options
        formData: { exts: {} }, //搜索/新增/编辑 表单数据
        activeName: 'search', //当前激活的tab,
        search_contact: '' //搜索联系人
      },
      serviceAppointment: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        data: [],
        formData: {},
        activeName: 'search',
        searchObj: {} //搜索选中要关联的工单对象
      },
      address: {
        relatedData: [],
        openEdit: false,
        formData: {}
      },
      machine: {
        relatedData: [], //关联的数组
        openRelate: false, //是否打开表单
        openEdit: false, //是否打开编辑表单
        data: [], //搜索已有的机台 返回的数组 可以叫options
        formData: { exts: {} }, //搜索/新增/编辑 表单数据
        activeName: 'search', //当前激活的tab,
        search_contact: '' //搜索
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      }
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  mounted() {
    window.$this = this;
    this.id = this.osg.param('id');
    this.osg.getFields('company', () => {
      this.getData();
    });
  },
  methods: {
    formatCallResult(val) {
      return this.osg.codelabel('callResult', val);
    },
    //上传头像图片文件转base64
    getFileToBase64(file) {
      var that = this;
      const isJPG = file.raw.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.osg.toast('上传头像图片只能是 JPG 格式！', 'error');
        return;
      }
      if (!isLt2M) {
        this.osg.toast('上传头像图片大小不能超过 2MB！', 'error');
        return;
      }
      this.$util.Base64.imgFile(file.raw).then(res => {
        if (res) {
          that.formData.avatar = res;
          that.$forceUpdate();
        } else {
          this.osg.toast('上传失败', 'error');
        }
      });
    },
    getData() {
      this.osg.ajax('basic/company/queryById.do', { id: this.id }, res => {
        this.companyType = res.type;
        this.$util.renderExtField(this.extFields, res);
        this.formData = res;

        this.tabClick({ name: this.activeTab });

        if (this.osg.param('id')) {
          //获取关联的联系人
          this.getContactData(null, this.osg.param('id'));
          //获取关联的工单
          this.getServiceAppointmentData(null, this.id);
          //获取关联的地址
          this.getAddressData();
          //获取关联的机台
          this.getMachineData(null, this.osg.param('id'));
          this.getContact();
        }
      });
    },
    getContact() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 50,
        'is:state|integer#and': 1
      };

      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.contactList = res.data;
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    getContactData(query, companyIds) {
      var params = {
        page: 1,
        rows: 10,
        'regex:name|string#or': query,
        'all:companyIds|string#and': companyIds, //只查关于自己公司的联系人
        'is:state|integer#and': 1
      };
      if (!companyIds) {
        params = {
          page: 1,
          rows: 10,
          'regex:name|string#or': query,
          'nin:_id|array#and': this.contact.relatedData.map(item => item._id).join(',') //只查关于自己公司的联系人
        };
      }
      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (companyIds) {
            this.contact.relatedData = res.data;
          } else {
            this.contact.data = res.data;
          }
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    getServiceAppointmentData(query, companyIds) {
      // this.serviceAppointment.searchObj = null;
      var params = {
        page: 1,
        rows: 10,
        'regex:name|string#or': query,
        'regex:title|string#or': query,
        'all:companyId|string#and': companyIds,
        'is:state|integer#and': 1
      };

      //搜索关联（全部工单），不返回已关联的工单
      // if (!companyIds) {
      //   params["is:companyId|null#and"] = null;
      // }

      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (companyIds) {
            this.serviceAppointment.relatedData = res.data;
          } else {
            this.serviceAppointment.data = res.data.filter(item => !item.companyId);
          }
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    getAddressData() {
      var params = {
        page: 1,
        rows: 10,
        'eq:typeId|string#and': this.id,
        'is:state|integer#and': 1
      };
      this.osg.ajax(
        'basic/address/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.address.relatedData = res.data;
        },
        { noload: true }
      );
    },
    getMachineData(query, companyId) {
      var params = {
        _all: '1',
        'regex:name|string#or': query,
        'regex:number|string#or': query,
        'is:companyId|string#or': companyId,
        'is:agentId|string#or': companyId,
        'is:state|integer#and': 1
      };
      this.osg.ajax(
        'biz/extForm/queryByColName/machine.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.number;
            item.value = item._id;
          });
          if (companyId) {
            this.machine.relatedData = res.data;
          } else {
            this.machine.data = res.data.filter(item => {
              return !item.companyId || !item.agentId;
            });
          }
        },
        { noload: true }
      );
    },
    removeContact(item) {
      this.osg.confirm(`删除与 "${item.name}" 的关联？`, () => {
        let delIndex = item.companyIds.indexOf(this.id);
        item.companyIds.splice(delIndex, 1);
        delete item.label;
        delete item.value;
        this.osg.ajax('basic/contacts/upsert.do', item, () => {
          this.osg.toast('保存成功！');
          this.getData();
        });
      });
    },
    //保存公司
    saveCompany(isEdit) {
      if (this.osg.validate('contactFormData')) {
        //将公司id保存到新创建的公司的companyIds字段
        if (isEdit) this.contact.formData.companyIds = [this.id];
        this.osg.ajax('basic/contacts/upsert.do', this.contact.formData, () => {
          this.getData();
        });
      }
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        this.osg.ajax('basic/company/upsert.do', this.formData, () => {
          this.osg.toast('保存成功！');
          this.getData();
        });
      }
    },
    //选择联系人保存
    doSaveContact() {
      if (!this.contact.search_contact) {
        this.osg.toast('联系人不能为空！', 'error');
        return;
      }
      let contactData = this.contact.data.filter(item => item._id == this.contact.search_contact);
      contactData[0].companyIds.push(this.osg.param('id'));
      this.osg.ajax('basic/contacts/upsert.do', contactData[0], () => {
        this.osg.toast('保存成功！');
        this.getData();
      });
    },
    //添加地址
    newAddress() {
      this.address.formData = {};
      this.address.openEdit = true;
    },
    //编辑地址
    editAddress(item) {
      var area = [];
      if (item.province) {
        area[0] = item.province;
      }
      if (item.city) {
        area[1] = item.city;
      }
      if (item.district) {
        area[2] = item.district;
      }
      item.area = area;
      this.address.formData = item;
      this.address.openEdit = true;
    },
    /**
     * 切换tab页
     */
    tabClick(tab) {
      switch (tab.name) {
        case 'log':
          this.getLog();
          break;
        case 'notes':
          this.getNote();
          break;
        case 'callRecords':
          this.getCallRecords();
          break;
        case 'history':
          this.getHistory();
          break;
        default:
          return;
      }
    },
    /**
     * 日志
     */
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'company',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    /**
     * 笔记
     */
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'company'
        },
        res => {
          this.noteData = res || [];
        }
      );
    },
    saveNote() {
      var params = {
        //sid，smodul，content，id，isDelete(值Y) 保存传123,修改传1234,删除传12345
        sid: this.id,
        smodule: 'company',
        content: this.vqeditor.content
      };
      debugger;
      this.osg.ajax('note/upsert.do', params, () => {
        this.osg.toast('保存成功！');
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    /**
     * 通话记录
     */
    getCallRecords() {
      this.callRecords.searchDate = this.callRecords.searchDate || [];
      this.osg.ajax(
        'basic/sobot/query.do',
        {
          bizId: this.id,
          bizType: 'Company',
          _all: '1',
          'regex:callerName|string#or': this.callRecords.searchValue,
          'regex:caller|string#or': this.callRecords.searchValue,
          'regex:callee|string#or': this.callRecords.searchValue,
          'gte:createTime|datetime#and': this.callRecords.searchDate[0],
          'lte:createTime|datetime#and': this.callRecords.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.callRecords.fpi = res;
        },
        { noload: true }
      );
    },
    /**
     * 属性变更记录
     */
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (this.options[row.field]) {
        return this.osg.codelabel(row.field, cellValue);
      } else {
        return cellValue;
      }
    },
    // 新增联系人
    newContact() {
      this.contact.openRelate = true;
      this.getContactData();
    },
    editContact(item) {
      this.contact.openEdit = true;
      item.exts = item.exts || {};
      this.contact.formData = item;
    },
    //重置公司
    initCompany() {
      this.contact.openEdit = false;
      this.contact.openRelate = false;
      this.contact.formData = { exts: {} };
      this.contact.search_contact = '';
    },
    // 关联工单
    newServiceAppointment() {
      this.serviceAppointment.openRelate = true;
      this.getServiceAppointmentData();
    },
    editServiceAppointment(item) {
      var area = [];
      if (item.province) {
        area[0] = item.province;
      }
      if (item.city) {
        area[1] = item.city;
      }
      if (item.district) {
        area[2] = item.district;
      }
      item.area = area;
      this.serviceAppointment.formData = item;
      this.serviceAppointment.openEdit = true;
    },
    saveServiceAppointment(type) {
      //搜索关联
      if (type == 'search') {
        this.serviceAppointment.searchObj.companyId = this.id;
        var obj = this.serviceAppointment.searchObj;
        obj.area = obj.area || [];
        if (obj.area.length > 0) {
          obj.province = obj.area[0] || '';
          if (obj.area.length > 1) {
            obj.city = obj.area[1] || '';
            if (obj.area.length > 2) {
              obj.district = obj.area[2] || '';
            }
          }
        }
        delete obj.area;
        delete obj.label;
        delete obj.value;
        this.osg.ajax(
          'basic/serviceAppointment/upsert.do',
          { data: JSON.stringify(this.serviceAppointment.searchObj) },
          () => {
            this.getData();
          }
        );
        this.initServiceAppointment();
      } else {
        this.serviceAppointment.formData.companyId = this.id;
        this.$nextTick(() => {
          let obj = JSON.parse(JSON.stringify(this.serviceAppointment.formData));
          obj.area = obj.area || [];
          if (obj.area.length > 0) {
            obj.province = obj.area[0];
            if (obj.area.length > 1) {
              obj.city = obj.area[1];
              if (obj.area.length > 2) {
                obj.district = obj.area[2];
              }
            }
          }
          delete obj.area;
          if (this.osg.validate('serviceAppointmentFormData')) {
            this.osg.ajax(
              'basic/serviceAppointment/upsert.do',
              { data: JSON.stringify(obj) },
              () => {
                this.getData();
              }
            );
            this.initServiceAppointment();
          }
        });
      }
    },
    removeServiceAppointment(item) {
      this.osg.confirm(`删除与 "${item.title}" 的关联？`, () => {
        item.companyId = '';
        delete item.label;
        delete item.value;
        this.osg.ajax('basic/serviceAppointment/upsert.do', { data: JSON.stringify(item) }, () => {
          this.getData();
        });
      });
    },
    initServiceAppointment() {
      this.serviceAppointment.searchObj = {};
      this.serviceAppointment.openEdit = false;
      this.serviceAppointment.openRelate = false;
      this.serviceAppointment.formData = {};
    },
    saveAddress() {
      if (this.osg.validate('addressFormData')) {
        var obj = this.address.formData;
        obj.area = obj.area || [];
        if (obj.area.length > 0) {
          obj.province = obj.area[0] || '';
          if (obj.area.length > 1) {
            obj.city = obj.area[1] || '';
            if (obj.area.length > 2) {
              obj.district = obj.area[2] || '';
            }
          }
        }
        delete obj.area;
        this.address.formData.typeId = this.id;
        this.osg.ajax('basic/address/upsert.do', this.address.formData, () => {
          this.getAddressData();
          this.initAddress();
        });
      }
    },
    removeAddress(item) {
      this.osg.confirm(`删除与 "${item.address}" 的关联？`, () => {
        item.typeId = '';
        this.osg.ajax('basic/address/upsert.do', item, () => {
          this.getAddressData();
          this.initAddress();
        });
      });
    },
    initAddress() {
      this.address.openEdit = false;
      this.address.formData = {};
    },
    /**
     * 关联机台
     */
    newMachine() {
      this.machine.openRelate = true;
      this.getMachineData();
    },
    saveMachine() {
      if (!this.machine.search_contact) {
        this.osg.toast('机台编号不能为空！', 'error');
        return;
      }
      let machineData = this.machine.data.filter(item => item._id == this.machine.search_contact);
      if (this.companyType == '1') {
        machineData[0].companyId = this.formData._id;
        machineData[0].companyName = this.formData.name;
        machineData[0].companyIdLabel = this.formData.name;
      } else {
        machineData[0].agentId = this.formData._id;
        machineData[0].agentName = this.formData.name;
        machineData[0].agentIdLabel = this.formData.name;
      }

      this.osg.ajax(
        'biz/extForm/upsert/7776751630287551811.do',
        { dataStr: JSON.stringify(machineData[0]) },
        () => {
          this.osg.toast('保存成功！');
          this.getData();
        }
      );
    },
    removeMachine(item) {
      this.osg.confirm(`删除与 "${item.number}" 的关联？`, () => {
        if (this.companyType == '1') {
          item.companyId = '';
          item.companyName = '';
          item.companyIdLabel = '';
        } else {
          item.agentId = '';
          item.agentName = '';
          item.agentIdLabel = '';
        }
        this.osg.ajax(
          'biz/extForm/upsert/7776751630287551811.do',
          { dataStr: JSON.stringify(item) },
          () => {
            this.getData();
          }
        );
      });
    },
    initMachine() {
      this.machine.searchObj = {};
      this.machine.openEdit = false;
      this.machine.openRelate = false;
      this.machine.formData = {};
    },
    /**
     * 外呼
     */
    callOut() {
      // 调用外呼接口-传外呼号码
      this.osg.sobot.callOut({
        destinationNumber: this.formData.phone,
        params: `{ "bizType": "Company","bizId":"${this.formData._id}"}`
      });
      // 打开笔记
      this.activeTab = 'notes';
      this.openNote = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.box-left {
  width: 400px !important;
  max-width: 400px !important;
  min-width: 400px !important;
}
.box-right {
  width: 300px !important;
  max-width: 300px !important;
  min-width: 300px !important;
}
</style>
